import styled from 'styled-components'

export const TrustedSlider = styled.div`
  margin: 48px auto 0px;
  padding: 0px 10px;

  .slick-dots {
    display: flex !important;
    justify-content: center;
    margin: 23px auto;
    padding: 0px;
  }

  .slick-dots li {
    margin: 9px;
    list-style-type: none;
  }

  .slick-dots li button {
    width: 8px;
    height: 8px;
    padding: 0px;
    background: #fdf4e1;
    border: none;
    font-size: 0px;
    cursor: pointer;
  }

  .slick-dots li.slick-active button {
    background: #000000;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 435px;
    margin: 0px auto;
    padding: 0px;

    .slick-dots {
      margin: 10px auto;
    }
  `};
`

export const TrustedCard = styled.div`
  height: 450px;
  width: calc(100% - 14px) !important;
  max-width: 400px;
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  background: #fff;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    height: 100px;
    width: 100%;
    background: linear-gradient(0deg, #ffffff 0%, rgba(255, 255, 255, 0.3) 100%);
  }

  .trusted-card-button {
    position: absolute;
    z-index: 1;
    bottom: 15px;
    left: 15px;
    width: 165px;
    height: 42px;
    user-select: auto;
  }

  ${({ theme }) => theme.mediaWidth.upToSmall`
    height: 356px;
  `};
`

export const TrustedCardImage = styled.img`
  width: 100%;
`
